<template>
  <div>
    <div class="place-self-center grid grid-cols-6 gap-4">
      <div
        id="header-footer-modal-preview-household"
        data-backdrop="static"
        class="modal grid content-center"
        data-test="add-household-modal"
      >
        <div class="modal-dialog modal-xl overflow-y-auto">
          <div
            class="modal-content bg-theme-25 justify-center content-center px-3"
          >
            <div class="modal-header">
              <h4 class="font-medium text-base mr-auto font-bold">
                {{ `${editModal ? "แก้ไข" : "เพิ่ม"}ครัวเรือน` }}
              </h4>
            </div>
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">

              <div class="col-span-12">
                <h3
                  class="font-medium text-base mr-auto font-bold text-theme-20"
                >
                  หัวหน้าครัวเรือน
                </h3>
              </div>
              <div
                :class="{
                  error:
                    v$.householdHeadIdCardNo.$errors.length || sumId === false,
                  'md:col-span-6 xs:col-span-9 md:px-1': !editModal,
                  'md:col-span-6 xs:col-span-12': editModal,
                }"
              >
                <label
                  for="household-head-idcard-input"
                  class="form-label text-theme-98"
                  >เลขบัตรประจำตัวประชาชน
                  <span class="text-theme-5">*</span></label
                >
                <input
                  id="household-head-idcard-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  placeholder="กรุณากรอกเลขบัตรประชาชน"
                  maxlength="13"
                  v-model="state.householdHeadIdCardNo"
                  data-test="household-head-idcard-input"
                  :disabled="editModal"
                  @input="onlyNumber"
                />
                <div v-if="sumId === false" class="error-msg">
                  กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง
                </div>
               <div v-if="getDataFromApi" class="error-msg whitespace-pre-line">
                          ไม่สามารถเพิ่มหัวหน้าครัวเรือนด้วยเลขบัตรประชาชนนี้ได้ เนื่องจากพบข้อมูลของบุคคลนี้ที่
                          {{getDataFromApi.village_name? `หมู่บ้าน${getDataFromApi.village_name}`:''}}
                          {{getDataFromApi.tumbol_name ? `ตำบล${getDataFromApi.tumbol_name}` : ''}}
                          {{getDataFromApi.amphur_name? `อำเภอ${getDataFromApi.amphur_name}`:''}}
                          {{getDataFromApi.province_name?`จังหวัด${getDataFromApi.province_name}`:''}}
                          {{`\nผู้รับผิดชอบ: `}}{{getDataFromApi.case_manager?.uid ? `${getDataFromApi.case_manager.uid} (${getDataFromApi.case_manager.title} ${getDataFromApi.case_manager.name} ${getDataFromApi.case_manager.surname})` : '-'}}
                        </div>
                <div
                  v-else
                  class="input-errors"
                  v-for="error of v$.householdHeadIdCardNo.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                class="md:col-span-6 xs:col-span-1 pt-7 px-1 flex gap-2 flex-wrap items-start"
                v-if="!editModal"
              >
                <button
                  type="button"
                  class="btn btn-primary font-medium flex-none"
                  :class="{ btnerror: checkClickbtn === false }"
                  data-test="submit-btn"
                  @click="checkHouseholdHead"
                >
                  ค้นหา
                </button>
                <button
                  v-show="showBoraButton"
                  type="button"
                  class="btn btn-primary font-medium flex-none"
                  @click="useBoraInfo"
                >
                  ตรวจสอบข้อมูลกับทะเบียนราษฎร์
                </button>
              </div>
              <div class="md:col-span-6" v-if="editModal"></div>
              <div
                class="md:col-span-2 xs:col-span-12 md:px-1"
                v-if="showHouseheadLayout"
              >
                <label for="title-selected" class="form-label text-theme-98"
                  >คำนำหน้าชื่อ <span class="text-theme-5">*</span></label
                >
                <v-select
                  class="selecthh"
                  data-test="dropdown-title"
                  id="dropdown-title"
                  label="label"
                  placeholder="กรุณาเลือกคำนำหน้า"
                  :class="{ errorselect: v$.titleSelected.$errors.length }"
                  :clearable="false"
                  :options="titles"
                  :disabled="editModal"
                  v-model="state.titleSelected"
                >
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"
                      ><ChevronDownIcon class="w-5 h-5"
                    /></span>
                  </template>
                </v-select>
                <div
                  class="input-errors"
                  v-for="error of v$.titleSelected.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                class="md:col-span-4 xs:col-span-12 pl-0 md:px-1"
                :class="{ error: v$.householdHeadFirstName.$errors.length }"
                v-if="showHouseheadLayout"
              >
                <label
                  for="household-head-firstname-input"
                  class="form-label text-theme-98"
                  >ชื่อ <span class="text-theme-5">*</span></label
                >
                <input
                  id="household-head-firstname-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  placeholder="กรุณากรอกชื่อ"
                  data-test="household-head-firstname-input"
                  :disabled="editModal"
                  v-model="state.householdHeadFirstName"
                />
                <div
                  class="input-errors"
                  v-for="error of v$.householdHeadFirstName.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                class="md:col-span-6 xs:col-span-12 md:px-1"
                :class="{ error: v$.householdHeadLastName.$errors.length }"
                v-if="showHouseheadLayout"
              >
                <label
                  for="household-head-lastname-input"
                  class="form-label text-theme-98"
                  >นามสกุล <span class="text-theme-5">*</span></label
                >
                <input
                  id="household-head-lastname-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  placeholder="กรุณากรอกนามสกุล"
                  data-test="household-head-lastname-input"
                  :disabled="editModal"
                  v-model="state.householdHeadLastName"
                />
                <div
                  class="input-errors"
                  v-for="error of v$.householdHeadLastName.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                class="md:col-span-6 xs:col-span-12 md:px-1"
                :class="{ error: v$.birthdate.$errors.length }"
                v-if="showHouseheadLayout"
              >
                <label
                  for="birthdate-lastname-input"
                  class="form-label text-theme-98"
                  >วัน/เดือน/ปีเกิด <span class="text-theme-5">*</span></label
                >
                <Datepicker
                  v-model="state.birthdate"
                  data-test="birth-date"
                  :enableTimePicker="false"
                  :monthChangeOnScroll="false"
                  selectText="ตกลง"
                  cancelText="ยกเลิก"
                  locale="th"
                  :month-year-component="monthYear"
                  :disabled="editModal"
                  :format="format"
                  :previewFormat="format"
                  :maxDate="new Date()"
                  preventMinMaxNavigation
                  :yearRange="[1900, new Date().getFullYear()]"
                ></Datepicker>
                <div
                  class="input-errors"
                  v-for="error of v$.birthdate.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                class="col-span-12 p-4 rounded-lg border border-theme-34 bg-theme-25 text-sm"
                v-if="showHouseheadLayout && boraInfoDisplay"
              >
                <div class="font-medium text-theme-20 mb-2">
                  ข้อมูลจากทะเบียนราษฎร์
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
                  <div>
                    <span class="text-theme-98 opacity-80">เพศ:</span>
                    {{ state.gender || "-" }}
                  </div>
                  <div>
                    <span class="text-theme-98 opacity-80">สัญชาติ:</span>
                    {{ state.nationality || "-" }}
                  </div>
                  <!-- <div>
                    <span class="text-theme-98 opacity-80">สถานะบุคคล:</span>
                    {{ state.personstatus || "-" }}
                  </div> -->
                  <div>
                    <span class="text-theme-98 opacity-80">เลขบัตรบิดา:</span>
                    {{ state.fatherpid || "-" }}
                  </div>
                  <div>
                    <span class="text-theme-98 opacity-80">ชื่อบิดา:</span>
                    {{ state.fathername || "-" }}
                  </div>
                  <div>
                    <span class="text-theme-98 opacity-80">สัญชาติบิดา:</span>
                    {{ state.fathernationality || "-" }}
                  </div>
                  <div></div>
                  <div>
                    <span class="text-theme-98 opacity-80">เลขบัตรมารดา:</span>
                    {{ state.motherpid || "-" }}
                  </div>
                  <div>
                    <span class="text-theme-98 opacity-80">ชื่อมารดา:</span>
                    {{ state.mothername || "-" }}
                  </div>
                  <div>
                    <span class="text-theme-98 opacity-80">สัญชาติมารดา:</span>
                    {{ state.mothernationality || "-" }}
                  </div>
                </div>
              </div>
              <div class="col-span-12 py-5">
                <div
                  class="w-full border-t dark:border-dark-5 border-theme-34"
                ></div>
              </div>

              <div class="col-span-12">
                <h3
                  class="font-medium text-base mr-auto font-bold text-theme-20"
                >
                  ลักษณะครัวเรือน
                </h3>
              </div>
              <div class="md:col-span-6 xs:col-span-12 px-1">
                <label
                  for="family-type-selected"
                  class="form-label text-theme-98"
                  >ลักษณะครัวเรือน <span class="text-theme-5">*</span></label
                >
                <v-select
                  class="selecthh"
                  data-test="family-type-selected"
                  id="family-type-selected"
                  placeholder="กรุณาเลือกลักษณะครัวเรือน"
                  label="label"
                  :clearable="false"
                  :options="familyType"
                  :class="{
                    errorselect: v$.typeofFamilySelected.$errors.length,
                  }"
                  v-model="state.typeofFamilySelected"
                >
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"
                      ><ChevronDownIcon class="w-5 h-5"
                    /></span>
                  </template>
                </v-select>
                <div
                  class="input-errors"
                  v-for="error of v$.typeofFamilySelected.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>

              <div class="col-span-12 py-5">
                <div
                  class="w-full border-t dark:border-dark-5 border-theme-34"
                ></div>
              </div>

              <div class="col-span-12">
                <h3
                  class="font-medium text-base mr-auto font-bold text-theme-20"
                >
                  รายละเอียดที่อยู่
                </h3>
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label for="modal-form-1" class="form-label text-theme-98"
                  >บ้านเลขที่ <span class="text-theme-5">*</span></label
                >
                <div :class="{ errorselect: v$.houseNoOption.$errors.length }">
                  <RadioCustomBtn
                    class="flex-1 border-0 shadow-none"
                    data-test="house-no-option"
                    name="houseNoOption"
                    firstOptionId="have-house-no-option"
                    secondOptionId="dont-have-house-no-option"
                    :firstOptionValue="1"
                    :secondOptionValue="0"
                    firstOptionText="มี"
                    secondOptionText="ไม่มี"
                    v-model="state.houseNoOption"
                  />
                </div>
                <div
                  class="input-errors"
                  v-for="error of v$.houseNoOption.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div class="col-span-6"></div>
              <div
                class="md:col-span-6 xs:col-span-12 md:px-1"
                v-if="state.houseNoOption === 1"
                :class="{ error: v$.houseNo.$errors.length }"
              >
                <label for="house-no-input" class="form-label text-theme-98"
                  >เลขที่ <span class="text-theme-5">*</span></label
                >
                <input
                  id="house-no-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  placeholder="กรุณากรอกบ้านเลขที่"
                  data-test="house-no-input"
                  v-model="state.houseNo"
                />
                <div
                  class="input-errors"
                  v-for="error of v$.houseNo.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                class="md:col-span-6 xs:col-span-12 md:px-1"
                v-if="state.houseNoOption === 1"
                :class="{ error: v$.houseCode.$errors.length }"
              >
                <label for="house-code-input" class="form-label text-theme-98"
                  >รหัสประจำบ้าน</label
                >
                <input
                  id="house-code-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  placeholder="รหัสประจำบ้าน"
                  data-test="house-code-input"
                  maxlength="11"
                  @input="onlyNumber"
                  v-model="state.houseCode"
                />
                <div
                  class="input-errors"
                  v-for="error of v$.houseCode.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label for="moo-input" class="form-label text-theme-98"
                  >หมู่ที่</label
                >
                <input
                  id="moo-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  placeholder="กรุณากรอกหมู่ที่"
                  data-test="moo-input"
                  v-model="moo"
                  @input="onlyNumber"
                />
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label for="lane-input" class="form-label text-theme-98"
                  >ซอย</label
                >
                <input
                  id="lane-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  placeholder="กรุณากรอกซอย"
                  data-test="lane-input"
                  v-model="lane"
                />
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label for="road-input" class="form-label text-theme-98"
                  >ถนน</label
                >
                <input
                  id="road-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  placeholder="กรุณากรอกถนน"
                  data-test="road-input"
                  v-model="road"
                />
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label for="province-selected" class="form-label text-theme-98"
                  >จังหวัด <span class="text-theme-5">*</span></label
                >
                <v-select
                  disabled
                  class="selecthh"
                  data-test="province-selected"
                  id="province-selected"
                  label="province_name"
                  placeholder="กรุณาเลือกจังหวัด"
                  :clearable="false"
                  :class="{ errorselect: v$.provinceSelected.$errors.length }"
                  v-model="state.provinceSelected"
                  @option:selected="getDistrict"
                >
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"
                      ><ChevronDownIcon class="w-5 h-5"
                    /></span>
                  </template>
                </v-select>
                <div
                  class="input-errors"
                  v-for="error of v$.provinceSelected.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label for="district-selected" class="form-label text-theme-98">
                  อำเภอ/เขต/อปท <span class="text-theme-5">*</span>
                  <div class="t-tooltip btn border-0 shadow-none p-0">
                    <span class="t-tooltip-text"
                      >กรณีที่อยู่ใน อปท ให้เลือก อปท เป็นหลัก</span
                    >
                    <InfoIcon class="w-4 h-4 ml-1" />
                  </div>
                </label>
                <v-select
                  class="selecthh"
                  data-test="district-selected"
                  id="district-selected"
                  label="amphur_name"
                  placeholder="กรุณาเลือกอำเภอ/เขต/อปท"
                  :clearable="false"
                  :options="districtArr"
                  :class="{ errorselect: v$.districtSelected.$errors.length }"
                  v-model="state.districtSelected"
                  @option:selected="getSubDistrict"
                >
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"
                      ><ChevronDownIcon class="w-5 h-5"
                    /></span>
                  </template>
                </v-select>
                <div
                  class="input-errors"
                  v-for="error of v$.districtSelected.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label
                  for="sub-district-selected"
                  class="form-label text-theme-98"
                  >ตำบล/แขวง <span class="text-theme-5">*</span></label
                >
                <v-select
                  class="selecthh"
                  data-test="sub-district-selected"
                  id="sub-district-selected"
                  label="tumbol_name"
                  placeholder="กรุณาเลือกตำบล/แขวง"
                  :class="{
                    errorselect: v$.subDistrictSelected.$errors.length,
                  }"
                  :clearable="false"
                  :options="subDistrictArr"
                  v-model="state.subDistrictSelected"
                  @option:selected="getVillage"
                >
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"
                      ><ChevronDownIcon class="w-5 h-5"
                    /></span>
                  </template>
                </v-select>
                <div
                  class="input-errors"
                  v-for="error of v$.subDistrictSelected.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label for="village-name-input" class="form-label text-theme-98"
                  >หมู่บ้าน/ชุมชน <span class="text-theme-5">*</span></label
                >
                <v-select
                  class="selecthh"
                  data-test="village-selected"
                  id="village-selected"
                  label="village_name"
                  placeholder="กรุณาเลือกหมู่บ้าน/ชุมชน"
                  :clearable="false"
                  :options="villageArr"
                  :class="{ errorselect: v$.villageSelected.$errors.length }"
                  v-model="state.villageSelected"
                >
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"
                      ><ChevronDownIcon class="w-5 h-5"
                    /></span>
                  </template>
                </v-select>
                <div
                  class="input-errors"
                  v-for="error of v$.villageSelected.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                class="md:col-span-6 xs:col-span-12 md:px-1"
                :class="{ error: v$.postCode.$errors.length }"
              >
                <label for="post-code-input" class="form-label text-theme-98"
                  >รหัสไปรษณีย์</label
                >
                <input
                  id="post-code-input"
                  type="text"
                  maxlength="5"
                  class="form-control placeholder-theme-19"
                  placeholder="กรุณากรอกรหัสไปรษณีย์"
                  data-test="post-code-input"
                  @input="onlyNumber"
                  v-model="state.postCode"
                />
                <div
                  class="input-errors"
                  v-for="error of v$.postCode.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div class="col-span-12 md:px-1">
                <label for="leaflet-map" class="form-label text-theme-98"
                  >พิกัดบ้าน</label
                >
                <div class="h-80 overflow-y-auto">
                  <LeafletMap
                    :edit="true"
                    :lng="lng"
                    :lat="lat"
                    @update:lat="updateLat"
                    @update:lng="updateLng"
                  />
                </div>
              </div>

              <div class="col-span-12 py-5">
                <div
                  class="w-full border-t dark:border-dark-5 border-theme-34"
                ></div>
              </div>

              <div class="col-span-12">
                <h3
                  class="font-medium text-base mr-auto font-bold text-theme-20"
                >
                  ลักษณะที่อยู่อาศัย
                </h3>
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label
                  for="house-type-selected"
                  class="form-label text-theme-98"
                  >ที่พักอาศัยตั้งอยู่บน
                  <span class="text-theme-5">*</span></label
                >
                <v-select
                  class="selecthh"
                  data-test="house-type-selected"
                  id="house-type-selected"
                  label="label"
                  placeholder="กรุณาเลือกกรรมสิทธิ์ที่ดิน"
                  :clearable="false"
                  :class="{
                    errorselect: validateHT.OGhouseTypeSelected.$errors.length,
                  }"
                  :options="houseType"
                  @option:selected="houseTypeChange"
                  v-model="stateHT.OGhouseTypeSelected"
                >
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"
                      ><ChevronDownIcon class="w-5 h-5"
                    /></span>
                  </template>
                </v-select>
                <div
                  class="input-errors"
                  v-for="error of validateHT.OGhouseTypeSelected.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                v-if="
                  state.houseTypeSelected.id === null ||
                    state.houseTypeSelected.id === 'HT1'
                "
                class="md:col-span-6"
              ></div>
              <div
                class="md:col-span-3 xs:col-span-12"
                v-if="state.houseTypeSelected.id === 'HT2'"
              >
                <label
                  for="house-type-selected"
                  class="form-label text-theme-98"
                  >ประเภทที่ดิน <span class="text-theme-5">*</span></label
                >
                <v-select
                  class="selecthh"
                  data-test="subhouse-type-selected"
                  id="subhouse-type-selected"
                  v-model="stateHT.OGsubHouseTypeSelected"
                  label="label"
                  placeholder="กรุณาเลือกลักษณะที่ดิน"
                  @option:selected="subHouseTypeChange"
                  :clearable="false"
                  :options="subhouseTypeH2"
                  :class="{
                    errorselect:
                      validateHT.OGsubHouseTypeSelected.$errors.length,
                  }"
                >
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"
                      ><ChevronDownIcon class="w-5 h-5"
                    /></span>
                  </template>
                </v-select>
                <div
                  class="input-errors"
                  v-for="error of validateHT.OGsubHouseTypeSelected.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <!-- subHT2 -->
              <div
                class="md:col-span-3 xs:col-span-12"
                v-if="
                  state.subHouseTypeSelected.id === 'เช่าที่ดิน' &&
                    state.houseTypeSelected.id === 'HT2'
                "
              >
                <label
                  for="house-type-selected"
                  class="form-label text-theme-98"
                  >ค่าเช่าเฉลี่ยเดือนละ
                  <span class="text-theme-5">*</span></label
                >
                <input
                  id="subhouse-type-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  data-test="subhouse-type-input"
                  :placeholder="'กรุณากรอกค่าเช่า'"
                  :class="{
                    errorselect: validateHT.detailSubHousetype.$errors.length,
                  }"
                  v-model="stateHT.detailSubHousetype"
                  @input="onlyNumber"
                />
                <div
                  class="input-errors"
                  v-for="error of validateHT.detailSubHousetype.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div
                class="md:col-span-3 xs:col-span-12"
                v-if="
                  state.houseTypeSelected.id === 'HT3' ||
                    state.houseTypeSelected.id === 'HT4' ||
                    state.houseTypeSelected.id === 'HT5'
                "
              >
                <label
                  for="subhouse-type-selected"
                  class="form-label text-theme-98"
                >
                  <span v-if="state.houseTypeSelected.id === 'HT3'"
                    >ประเภทที่ดิน</span
                  >
                  <span v-if="state.houseTypeSelected.id === 'HT4'"
                    >ค่าเช่าเดือนละ</span
                  >
                  <span v-if="state.houseTypeSelected.id === 'HT5'">อื่นๆ</span>
                  <span class="text-theme-5">*</span>
                </label>
                <div v-if="state.houseTypeSelected.id === 'HT3'">
                  <v-select
                    class="selecthh"
                    data-test="subhouse-type-selected-HT3"
                    id="subhouse-type-selected"
                    label="label"
                    placeholder="กรุณาเลือกประเภทที่สาธารณะ(บุกรุก)"
                    :options="subhouseTypeH3"
                    :clearable="false"
                    :class="{
                      errorselect:
                        validateHT.OGsubHouseTypeSelected.$errors.length,
                    }"
                    @option:selected="subHouseTypeChange"
                    v-model="stateHT.OGsubHouseTypeSelected"
                  >
                    <template #no-options="{}">
                      ไม่พบข้อมูล
                    </template>
                    <template #open-indicator="{ attributes }">
                      <span v-bind="attributes"
                        ><ChevronDownIcon class="w-5 h-5"
                      /></span>
                    </template>
                  </v-select>
                  <div
                    class="input-errors"
                    v-for="error of validateHT.OGsubHouseTypeSelected.$errors"
                    :key="error.$uid"
                  >
                    <div class="error-msg">{{ error.$message }}</div>
                  </div>
                </div>
                <div
                  v-if="
                    state.houseTypeSelected.id === 'HT4' ||
                      state.houseTypeSelected.id === 'HT5'
                  "
                >
                  <input
                    id="subhouse-type-input"
                    type="text"
                    class="form-control placeholder-theme-19"
                    data-test="subhouse-type-input-HT45"
                    :class="{
                      errorselect: validateHT.detailSubHousetype.$errors.length,
                    }"
                    :placeholder="
                      state.houseTypeSelected.id === 'HT4'
                        ? 'กรุณากรอกค่าเช่า'
                        : 'กรุณาระบุ'
                    "
                    v-model="stateHT.detailSubHousetype"
                    @input="onlyNumber"
                  />
                  <div
                    class="input-errors"
                    v-for="error of validateHT.detailSubHousetype.$errors"
                    :key="error.$uid"
                  >
                    <div class="error-msg">{{ error.$message }}</div>
                  </div>
                </div>
              </div>
              <div
                class="md:col-span-3 xs:col-span-12"
                v-if="
                  state.subHouseTypeSelected.id === 'PL5' &&
                    state.houseTypeSelected.id === 'HT3'
                "
              >
                <label
                  for="house-type-selected"
                  class="form-label text-theme-98"
                  >กรุณาระบุ <span class="text-theme-5">*</span></label
                >
                <input
                  id="subhouse-type-input"
                  type="text"
                  class="form-control placeholder-theme-19"
                  data-test="subhouse-type-input-PL5"
                  :placeholder="'กรุณาระบุ'"
                  :class="{
                    errorselect: validateHT.detailSubHousetype.$errors.length,
                  }"
                  v-model="stateHT.detailSubHousetype"
                />
                <div
                  class="input-errors"
                  v-for="error of validateHT.detailSubHousetype.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>






              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label for="house-solid-option" class="form-label text-theme-98"
                  >ลักษณะที่อยู่อาศัย <span class="text-theme-5">*</span></label
                >
                <div
                  :class="{ errorselect: v$.houseSolidOption.$errors.length }"
                >
                  <RadioCustomBtn
                    class="flex-1 border-0 shadow-none"
                    data-test="house-solid-option"
                    name="houseSolidOption"
                    firstOptionId="solid-house-option"
                    secondOptionId="unsolid-house-option"
                    :firstOptionValue="1"
                    :secondOptionValue="0"
                    firstOptionText="มีความแข็งแรง"
                    secondOptionText="ไม่มีความแข็งแรง"
                    v-model="state.houseSolidOption"
                  />
                </div>
                <div
                  class="input-errors"
                  v-for="error of v$.houseSolidOption.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div class="md:col-span-6 xs:col-span-12 md:px-1">
                <label
                  for="env-suitable-option"
                  class="form-label text-theme-98"
                  >เหมาะสมต่อเด็ก ผู้สูงอายุ คนพิการ
                  <span class="text-theme-5">*</span></label
                >
                <div
                  :class="{ errorselect: v$.envSuitableOption.$errors.length }"
                >
                  <RadioCustomBtn
                    class="flex-1 border-0 shadow-none"
                    data-test="env-suitable-option"
                    name="envSuitableOption"
                    firstOptionId="env-suitable-option"
                    secondOptionId="env-unsuitable-option"
                    :firstOptionValue="1"
                    :secondOptionValue="0"
                    firstOptionText="เหมาะสม"
                    secondOptionText="ไม่เหมาะสม"
                    v-model="state.envSuitableOption"
                  />
                  
<!--               <div class="col-span-12 py-5">
                        <div class="w-full border-t dark:border-dark-5 border-theme-34"></div>
                    </div>
                    
                    <div class="col-span-12">
                      <h3 class="font-medium text-base mr-auto font-bold text-theme-20">
                        หัวหน้าครัวเรือน
                      </h3>
                    </div>
                    <div :class="{ error: v$.householdHeadIdCardNo.$errors.length || sumId === false, 'md:col-span-6 xs:col-span-9 md:px-1': !editModal ,'md:col-span-6 xs:col-span-12': editModal}" >
                        <label for="household-head-idcard-input" class="form-label text-theme-98">เลขบัตรประจำตัวประชาชน <span class="text-theme-5">*</span></label>
                        <input 
                          id="household-head-idcard-input" 
                          type="text" 
                          class="form-control placeholder-theme-19" 
                          placeholder="กรุณากรอกเลขบัตรประชาชน" 
                          maxlength="13"
                          v-model="state.householdHeadIdCardNo" 
                          data-test="household-head-idcard-input"
                          :disabled="editModal"
                          @input="onlyNumber"/>
                        <div v-if="sumId === false" class="error-msg">
                          กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง
                        </div>
                        <div v-if="getDataFromApi" class="error-msg whitespace-pre-line">
                          ไม่สามารถเพิ่มหัวหน้าครัวเรือนด้วยเลขบัตรประชาชนนี้ได้ เนื่องจากพบข้อมูลของบุคคลนี้ที่
                          {{getDataFromApi.village_name? `หมู่บ้าน${getDataFromApi.village_name}`:''}}
                          {{getDataFromApi.tumbol_name ? `ตำบล${getDataFromApi.tumbol_name}` : ''}}
                          {{getDataFromApi.amphur_name? `อำเภอ${getDataFromApi.amphur_name}`:''}}
                          {{getDataFromApi.province_name?`จังหวัด${getDataFromApi.province_name}`:''}}
                          {{`\nผู้รับผิดชอบ: `}}{{getDataFromApi.case_manager?.uid ? `${getDataFromApi.case_manager.uid} (${getDataFromApi.case_manager.title} ${getDataFromApi.case_manager.name} ${getDataFromApi.case_manager.surname})` : '-'}}
                        </div>
                        <div v-else class="input-errors" v-for="error of v$.householdHeadIdCardNo.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>     
                        </div>
                    </div>
                    <div class="md:col-span-6 xs:col-span-1 pt-7 px-1 flex gap-2 flex-wrap" v-if="!editModal">
                      <button
                        type="button"
                        class="btn btn-primary font-medium"
                        :class="{ btnerror: checkClickbtn === false }"
                        data-test="submit-btn"
                        @click="checkHouseholdHead">
                        ค้นหา
                      </button>
                      <button
                        v-show="showBoraButton"
                        type="button"
                        class="btn btn-primary font-medium"
                        @click="useBoraInfo">
                        ตรวจสอบข้อมูลกับทะเบียนราษฎร์
                      </button>
                    </div>
                    <div class="md:col-span-6" v-if="editModal"></div>
                    <div class="md:col-span-2 xs:col-span-12 md:px-1" v-if="showHouseheadLayout"> 
                        <label for="title-selected" class="form-label text-theme-98">คำนำหน้าชื่อ <span class="text-theme-5">*</span></label>
                          <v-select
                            class="selecthh"
                            data-test="dropdown-title"
                            id="dropdown-title"
                            label="label"
                            placeholder="กรุณาเลือกคำนำหน้า"
                            :class="{ errorselect: v$.titleSelected.$errors.length }"
                            :clearable="false"
                            :options="titles"
                            :disabled="editModal"
                            v-model="state.titleSelected">
                            <template #no-options="{}">
                              ไม่พบข้อมูล
                            </template>
                            <template #open-indicator="{ attributes }">
                              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                          </v-select>
                        <div class="input-errors" v-for="error of v$.titleSelected.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="md:col-span-4 xs:col-span-12 pl-0 md:px-1" :class="{ error: v$.householdHeadFirstName.$errors.length }" v-if="showHouseheadLayout">
                        <label for="household-head-firstname-input" class="form-label text-theme-98">ชื่อ <span class="text-theme-5">*</span></label>
                        <input 
                          id="household-head-firstname-input" 
                          type="text" 
                          class="form-control placeholder-theme-19" 
                          placeholder="กรุณากรอกชื่อ" 
                          data-test="household-head-firstname-input"
                          :disabled="editModal"
                          v-model="state.householdHeadFirstName"/>
                        <div class="input-errors" v-for="error of v$.householdHeadFirstName.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="md:col-span-6 xs:col-span-12 md:px-1" :class="{ error: v$.householdHeadLastName.$errors.length }" v-if="showHouseheadLayout">
                        <label for="household-head-lastname-input" class="form-label text-theme-98">นามสกุล <span class="text-theme-5">*</span></label>
                        <input 
                          id="household-head-lastname-input" 
                          type="text" 
                          class="form-control placeholder-theme-19" 
                          placeholder="กรุณากรอกนามสกุล" 
                          data-test="household-head-lastname-input"
                          :disabled="editModal"
                          v-model="state.householdHeadLastName"/>
                        <div class="input-errors" v-for="error of v$.householdHeadLastName.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="md:col-span-6 xs:col-span-12 md:px-1" :class="{ error: v$.birthdate.$errors.length }" v-if="showHouseheadLayout">
                        <label for="birthdate-lastname-input" class="form-label text-theme-98">วัน/เดือน/ปีเกิด <span class="text-theme-5">*</span></label>
                        <Datepicker
                            v-model="state.birthdate"
                            data-test="birth-date"
                            :enableTimePicker="false"
                            :monthChangeOnScroll="false"
                            selectText="ตกลง"
                            cancelText="ยกเลิก"
                            locale="th"
                            :month-year-component="monthYear"
                            :disabled="editModal"
                            :format="format"
                            :previewFormat="format"
                            :maxDate="new Date()"
                            preventMinMaxNavigation
                            :yearRange="[1900, new Date().getFullYear()]"
                        ></Datepicker>
                        <div class="input-errors" v-for="error of v$.birthdate.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div> -->
                </div>
                <div
                  class="input-errors"
                  v-for="error of v$.envSuitableOption.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
            </div>
            <div class="modal-footer text-right">
              <button
                type="button"
                class="btn btn-outline-secondary mr-1"
                data-test="cancel-btn"
                @click="closeModal('canceled')"
              >
                ยกเลิก
              </button>
              <button
                type="button"
                class="btn btn-primary font-medium"
                data-test="submit-btn"
                @click="submitAddHouseholdForm"
              >
                บันทึก
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, watch, defineAsyncComponent, computed } from "vue";
import RadioCustomBtn from "@/components/base/radio-custom-button/index.vue";
import LeafletMap from "@/components/leaflet-map/index.vue";
import useVuelidate from "@vuelidate/core";
import { required, helpers, minLength, maxLength } from "@vuelidate/validators";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import store from "@/store";
import { useBoraData } from "@/utils/useBoraData";
const { getPersonInfoFromBora, boraHouseholdInfo } = useBoraData();
import { useRoute } from "vue-router";
var md5 = require("md5");
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});

const props = defineProps({
  addHouseholdModal: { type: Boolean, default: false },
  editModal: { type: Boolean, default: false },
});
const emit = defineEmits(["modal-value"]);

var localstorageVT = "";

const MonthYear = defineAsyncComponent(() =>
  import("@/components/custom-datepicker/monthComponent.vue")
);
const lat = ref(13.720564133220474);
const lng = ref(100.49031257629396);
// const houseCode = ref('');
const moo = ref("");
const road = ref("");
const lane = ref("");
const filename = ref("");
const imageUrl = ref("");
const sumId = ref(true);
const filelist = reactive([]);
const districtArr = ref([]);
const subDistrictArr = ref([]);
const villageArr = ref([]);
const showHouseheadLayout = ref(false);
const showBoraButton = ref(false);
const boraInfoDisplay = ref(null);
const submitBtn = ref(false);
const getDataFromApi = ref(null);
const checkClickbtn = ref(null);
const managerData = ref(null);
const getMemberData = ref(null);
// const municipality_code = ref('');
// const municipality_name = ref('');
const subhouse_type_selected = ref(null);
const editModal = ref(props.editModal);
const getHouseHoldData = ref(null);
const route = useRoute();
const detailSubHouseTypeArr = ref([]);
const familyType = reactive([
  { id: "HHT1", label: "อยู่คนเดียว" },
  { id: "HHT2", label: "ครัวเรือนเดี่ยว (พ่อ แม่ ลูก)" },
  {
    id: "HHT3",
    label: "ครัวเรือนขยาย (พ่อ แม่ ลูก พี่ น้อง ปู่ ย่า ตา ยาย หลาน)",
  },
]);
const titles = reactive([
  { id: "นาย", label: "นาย" },
  { id: "นาง", label: "นาง" },
  { id: "นางสาว", label: "นางสาว" },
]);
const houseType = reactive([
  { id: "HT1", label: "ที่ดินมีกรรมสิทธิ์ของตนเอง" },
  { id: "HT2", label: "ที่ดินของผู้อื่น" },
  { id: "HT3", label: "ที่ดินสาธารณะ (บุกรุก)" },
  { id: "HT4", label: "เช่า" },
  { id: "HT5", label: "อื่นๆ" },
]);
const subhouseTypeH2 = reactive([
  { id: "เช่าที่ดิน", label: "เช่าที่ดิน" },
  { id: "อาศัยที่ดินผู้อื่น", label: "อาศัยที่ดินผู้อื่น" },
]);
const subhouseTypeH3 = reactive([
  { id: "PL1", label: "ป่าสงวน" },
  { id: "PL2", label: "อุทยาน" },
  { id: "PL3", label: "เจ้าท่า" },
  { id: "PL4", label: "ป่าชายเลน" },
  { id: "PL5", label: "อื่นๆ" },
]);
var state = reactive({
  houseNo: "",
  houseCode: "",
  householdHeadFirstName: "",
  householdHeadLastName: "",
  householdHeadIdCardNo: "",
  postCode: "",
  villageSelected: null,
  provinceSelected: null,
  districtSelected: null,
  subDistrictSelected: null,
  titleSelected: null,
  houseTypeSelected: { id: null, label: null },
  typeofFamilySelected: null,
  envSuitableOption: 1,
  houseNoOption: 1,
  houseSolidOption: 1,
  birthdate: null,
  subHouseTypeSelected: { id: null, label: null },
});
const rules = {
  houseNo: { required: helpers.withMessage("กรุณากรอกบ้านเลขที่", required) },
  birthdate: {
    required: helpers.withMessage("กรุณาเลือกวัน/เดือน/ปีเกิด", required),
  },
  houseTypeSelected: {
    required: helpers.withMessage("กรุณาเลือกกรรมสิทธิ์ที่ดิน", required),
  },
  titleSelected: {
    required: helpers.withMessage("กรุณาเลือกคำนำหน้าชื่อ", required),
  },
  householdHeadFirstName: {
    required: helpers.withMessage("กรุณากรอกชื่อ", required),
  },
  householdHeadLastName: {
    required: helpers.withMessage("กรุณากรอกนามสกุล", required),
  },
  provinceSelected: {
    required: helpers.withMessage("กรุณาเลือกจังหวัด", required),
  },
  districtSelected: {
    required: helpers.withMessage("กรุณาเลือกเขต", required),
  },
  subDistrictSelected: {
    required: helpers.withMessage("กรุณาเลือกแขวง", required),
  },
  villageSelected: {
    required: helpers.withMessage("กรุณาเลือกหมู่บ้าน/ชุมชน", required),
  },
  envSuitableOption: {
    required: helpers.withMessage("กรุณาเลือกความเหมาะสม", required),
  },
  houseNoOption: {
    required: helpers.withMessage("กรุณาเลือกบ้านเลขที่", required),
  },
  houseSolidOption: {
    required: helpers.withMessage("กรุณาเลือกลักษณะที่อยู่อาศัย", required),
  },
  typeofFamilySelected: {
    required: helpers.withMessage("กรุณาเลือกลักษณะครอบครัว", required),
  },
  householdHeadIdCardNo: {
    minLength: helpers.withMessage(
      "กรุณากรอกเลขบัตรประชาชน 13 หลัก",
      minLength(13)
    ),
    maxLength: helpers.withMessage(
      "กรุณากรอกเลขบัตรประชาชน 13 หลัก",
      maxLength(13)
    ),
    required: helpers.withMessage("กรุณากรอกเลขบัตรประชาชน 13 หลัก", required),
  },
  postCode: {
    minLength: helpers.withMessage(
      "กรุณากรอกรหัสไปรษณีย์ 5 หลัก",
      minLength(5)
    ),
    maxLength: helpers.withMessage(
      "กรุณากรอกรหัสไปรษณีย์ 5 หลัก",
      maxLength(5)
    ),
  },
  houseCode: {
    minLength: helpers.withMessage(
      "กรุณากรอกรหัสประจำบ้าน 11 หลัก",
      minLength(11)
    ),
    maxLength: helpers.withMessage(
      "กรุณากรอกรหัสประจำบ้าน 11 หลัก",
      maxLength(11)
    ),
  },
};
var stateHT = reactive({
  OGhouseTypeSelected: null,
  OGsubHouseTypeSelected: null,
  detailSubHousetype: null,
});
const rulesHT = {
  OGhouseTypeSelected: {
    required: helpers.withMessage("กรุณาเลือกกรรมสิทธิ์ที่ดิน", required),
  },
  OGsubHouseTypeSelected: {
    required: helpers.withMessage("กรุณาเลือกประเภท", required),
  },
  detailSubHousetype: {
    required: helpers.withMessage("กรุณากรอกรายละเอียด", required),
  },
};
const v$ = useVuelidate(rules, state);
const validateHT = useVuelidate(rulesHT, stateHT);
const monthYear = computed(() => MonthYear);
const format = (date) => {
  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear() + 543;

  return `${day}/${month}/${year}`;
};
watch(
  () => props.addHouseholdModal,
  async () => {
    if (props.addHouseholdModal) {
      if (props.editModal) {
        editModal.value = true;
        showHouseheadLayout.value = true;
        getHouseHold(route.params.hhid);
        cash("#header-footer-modal-preview-household").modal("show");
      } else {
        await getUser();
        if (managerData.value) {
          cash("#header-footer-modal-preview-household").modal("show");
          state.provinceSelected = {
            province_name: store.getters["userAuth/getUserProvinceName"],
            _id: {
              province_ID: store.getters["userAuth/getUserProvinceCode"],
            },
          };
          getDistrict(state.provinceSelected);
        } else {
          Swal.fire({
            icon: "warning",
            text: "ไม่พบข้อมูล Case Manager กรุณาติดต่อเจ้าหน้า พม.",
            timer: 3000,
          });
          emit("modal-value", "cancel");
        }
      }
    }
  }
);
watch(
  () => state.householdHeadIdCardNo,
  () => {
    if (state.householdHeadIdCardNo.length === 13) {
      sumId.value = idState();

      if (!editModal.value) {
        checkClickbtn.value = false;
        showHouseheadLayout.value = false;
        showBoraButton.value = false;
      }
    }
  }
);
const updateLat = (val) => {
  lat.value = val;
};
const updateLng = (val) => {
  lng.value = val;
};
const onlyNumber = async () => {
  getDataFromApi.value = null;
  moo.value = (moo.value || "").replace(/[^\d]/g, "");
  state.postCode = (state.postCode || "").replace(/[^\d]/g, "");
  state.houseCode = (state.houseCode || "").replace(/[^\d]/g, "");
  state.householdHeadIdCardNo = (state.householdHeadIdCardNo || "").replace(
    /[^\d]/g,
    ""
  );
  if (
    state.houseTypeSelected.id === "HT4" ||
    state.houseTypeSelected.id === "HT2"
  ) {
    stateHT.detailSubHousetype = stateHT.detailSubHousetype.replace(
      /[^\d]/g,
      ""
    );
  }
  if (state.householdHeadIdCardNo.length === 0) {
    sumId.value = null;
    showHouseheadLayout.value = false;
    showBoraButton.value = false;
    boraInfoDisplay.value = null;
  } else if (
    state.householdHeadIdCardNo.length < 13 &&
    state.householdHeadIdCardNo.length !== 0
  ) {
    sumId.value = null;
    showBoraButton.value = false;
    boraInfoDisplay.value = null;
  }
};
const addBoraButton = () => {
  showBoraButton.value = true;
};
const checkHouseholdHead = async () => {
  sumId.value = await idState();
  showBoraButton.value = false;
  boraInfoDisplay.value = null;
  var isFormCorrect = await v$.value.householdHeadIdCardNo.$validate();
  checkClickbtn.value = true;
  if (sumId.value && isFormCorrect) {
    try {
      axios
        .post(`${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`, {
          member_nid: state.householdHeadIdCardNo,
        })
        .then((res) => {
          showHouseheadLayout.value = true;
          if (res.status === 200) {
            if (typeof res.data.national_id != "undefined") {
              if (res.data.national_id == state.householdHeadIdCardNo) {
                // duplicate check nationid
                getDataFromApi.value = res.data;
                showHouseheadLayout.value = false;
                showBoraButton.value = false;
              } else {
                getDataFromApi.value = null;
                showHouseheadLayout.value = true;
                addBoraButton();
              }
            } else {
              getDataFromApi.value = null;
              showHouseheadLayout.value = true;
              addBoraButton();
            }
            state.householdHeadFirstName = null;
            state.householdHeadLastName = null;
            state.titleSelected = null;
            state.birthdate = null;
          } else {
            swalCustom.fire({
              text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
              icon: "warning",
              //timer: 3000, //timeOut for auto-close
              confirmButtonText: "ปิด",
            });
          }
        });
    } catch (error) {
      console.log(error.message);
    }
  }
};
// const getProvince = () => {``
//   try {
//     axios.get('https://mso-logbook.m-society.go.th/api/refadms/')
//     .then((response) => {
//         provinceArr.value =  response.data.sort((a,b) => a.province_name > b.province_name ? 1 : -1 )
//       })
//   } catch (error) {
//     console.log(error.message);
//   }
// };
const getDistrictEditmodal = (province_data) => {
  var provinceid = parseInt(province_data._id.province_ID);
  try {
    axios
      .get(`${process.env.VUE_APP_BASE_API}refadms/`, {
        params: {
          prov: provinceid,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          districtArr.value = response.data.sort((a, b) =>
            a.amphur_name > b.amphur_name ? 1 : -1
          );
          //find mso_osm with prov id and then set mso_osm to state.districtSelected
          let findMsoFromProv = districtArr.value.find(
            (item) => item._id.province_ID == provinceid
          );
          state.districtSelected.mso_osm = findMsoFromProv.mso_osm;
        } else {
          console.log(response.status.statusText);
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
const getDistrict = (province_data) => {
  state.districtSelected = null;
  state.subDistrictSelected = null;
  state.villageSelected = null;
  var provinceid = parseInt(province_data._id.province_ID);
  try {
    axios
      .get(`${process.env.VUE_APP_BASE_API}refadms/`, {
        params: {
          prov: provinceid,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          districtArr.value = response.data.sort((a, b) =>
            a.amphur_name > b.amphur_name ? 1 : -1
          );
        } else {
          console.log(response.status.statusText);
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
const getSubDistrictEditmodal = (district_data, province_data) => {
  var districtid = district_data._id.amphur_ID;
  try {
    axios
      .get(`${process.env.VUE_APP_BASE_API}refadms/`, {
        params: {
          prov: province_data._id.province_ID,
          amp: districtid,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          subDistrictArr.value = response.data.sort((a, b) =>
            a.tumbol_name > b.tumbol_name ? 1 : -1
          );
        } else {
          console.log(response.status.statusText);
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
// const getSubDistrict = (district_data) => {
//   state.subDistrictSelected = null;
//   state.villageSelected = null;
//   var districtid = district_data._id.amphur_ID;
//   try {
//     axios
//       .get(`${process.env.VUE_APP_BASE_API}refadms/`, {
//         params: {
//           prov: district_data._id.province_ID,
//           amp: districtid,
//         },
//       })
//       .then((response) => {
//         if (response.status === 200) {
//           subDistrictArr.value = response.data.sort((a, b) =>
//             a.tumbol_name > b.tumbol_name ? 1 : -1
//           );
//         } else {
//           console.log(response.status.statusText);
//         }
//       });
//   } catch (error) {
//     console.log(error.message);
//   }
// };
const getSubDistrict = async (district_data) => {
  state.subDistrictSelected = null
  state.villageSelected = null
  var districtid = district_data._id.amphur_ID
  try {
    const response = await axios.get(`${process.env.VUE_APP_BASE_API}refadms/`, {
      params: {
        prov: district_data._id.province_ID,
        amp: districtid
      }
    })
    if (response.status === 200) {
      subDistrictArr.value = response.data.sort((a, b) => a.tumbol_name > b.tumbol_name ? 1 : -1)
    }
    else {
      console.log(response.status.statusText);
    }
  } catch (error) {
    console.log(error.message);
  }
};
const getVillageEditmodal = (tumbol_data, district_data, province_data) => {
  var tumbolid = tumbol_data._id.tumbol_ID;
  try {
    axios
      .get(`${process.env.VUE_APP_BASE_API}refadms/`, {
        params: {
          prov: province_data._id.province_ID,
          amp: district_data._id.amphur_ID,
          tam: tumbolid,
        },
      })
      .then((response) => {
        // const tempArr = response.data.filter(name => name.village_name = name.village_name.replace("หมู่ nan ", ""))
        // if (response.data.village_name === ""){
        //   village_name
        // }
        if (response.status === 200) {
          villageArr.value = response.data.sort((a, b) =>
            a.village_name > b.village_name ? 1 : -1
          );
        } else {
          console.log(response.status.statusText);
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
// const getVillage = (tumbol_data) => {
//   state.villageSelected = null;
//   var tumbolid = tumbol_data._id.tumbol_ID;
//   try {
//     axios
//       .get(`${process.env.VUE_APP_BASE_API}refadms/`, {
//         params: {
//           prov: tumbol_data._id.province_ID,
//           amp: tumbol_data._id.amphur_ID,
//           tam: tumbolid,
//         },
//       })
//       .then((response) => {
//         // const tempArr = response.data.filter(name => name.village_name = name.village_name.replace("หมู่ nan ", ""))
//         // if (response.data.village_name === ""){
//         //   village_name
//         // }
//         if (response.status === 200) {
//           villageArr.value = response.data.sort((a, b) =>
//             a.village_name > b.village_name ? 1 : -1
//           );
//         } else {
//           console.log(response.status.statusText);
//         }
//       });
//   } catch (error) {
//     console.log(error.message);
//   }
// };
const getVillage = async (tumbol_data) => {
  state.villageSelected = null
  var tumbolid = tumbol_data._id.tumbol_ID
  try {
    const response = await axios.get(`${process.env.VUE_APP_BASE_API}refadms/`, {
      params: {
        prov: tumbol_data._id.province_ID,
        amp: tumbol_data._id.amphur_ID,
        tam: tumbolid
      }
    })
    if (response.status === 200){
      villageArr.value =  response.data.sort((a,b) => a.village_name > b.village_name ? 1 : -1 )
    }
    else {
      console.log(response.status.statusText);
    }
  } catch (error) {
    console.log(error.message);
  }
};
const getUser = async () => {
  localstorageVT = JSON.parse(localStorage.getItem("volunteerData"));
  var tempUID = "";
  if (
    store.getters["userAuth/getUserRoleCode"] === "cm" ||
    store.getters["userAuth/getUserRoleCode"] === "scm"
  ) {
    tempUID = store.getters["userAuth/getUsername"];
    localstorageVT = {
      uid: "",
      title: "",
      name: "",
      surname: "",
      national_id: "",
    };
  } else {
    tempUID = localstorageVT.cm_uid;
  }
  try {
    await axios
      .post(`${process.env.VUE_APP_BASE_API}user/getUser`, {
        uid: tempUID,
      })
      .then((res) => {
        if (res.status === 200) {
          managerData.value = res.data[0];
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
const getMember = async (id_card) => {
  try {
    axios
      .post(`${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`, {
        member_nid: id_card,
      })
      .then((res) => {
        if (res.status === 200) {
          getMemberData.value = res.data;
          state.householdHeadIdCardNo = getMemberData.value.national_id;
          state.householdHeadFirstName = getMemberData.value.name;
          state.householdHeadLastName = getMemberData.value.surname;
          state.titleSelected = getMemberData.value.title;
          state.birthdate = getMemberData.value.birthdate;
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
const getHouseHold = async (hh_id) => {
  try {
    axios
      .post(`${process.env.VUE_APP_BASE_API}household/getHouseSurveyById`, {
        houseId: hh_id,
      })
      .then((res) => {
        if (res.status === 200) {
          getHouseHoldData.value = res.data;
          moo.value = getHouseHoldData.value.moo;
          lane.value = getHouseHoldData.value.soi;
          road.value = getHouseHoldData.value.road;
          state.houseCode = getHouseHoldData.value.hh_code;
          lat.value = getHouseHoldData.value.latitude;
          lng.value = getHouseHoldData.value.longitude;
          state.postCode = getHouseHoldData.value.postcode;
          (state.houseNo = getHouseHoldData.value.hnum),
            // state.householdHeadFirstName =  getHouseHoldData.value,
            // state.householdHeadLastName = getHouseHoldData.value,
            // state.householdHeadIdCardNo = getHouseHoldData.value,
            (state.envSuitableOption = getHouseHoldData.value.env_suitable),
            (state.houseNoOption = getHouseHoldData.value.have_num),
            (state.houseSolidOption = getHouseHoldData.value.house_solid);
          (state.villageSelected = {
            _id: {
              village_ID: getHouseHoldData.value.village_code,
            },
            village_name: getHouseHoldData.value.village_name,
          }),
            (state.provinceSelected = {
              province_name: getHouseHoldData.value.province_name,
              _id: {
                province_ID: getHouseHoldData.value.province_code,
              },
            });
          (state.districtSelected = {
            _id: {
              amphur_ID: getHouseHoldData.value.amphur_code,
            },
            amphur_name: getHouseHoldData.value.amphur_name,
          }),
            (state.subDistrictSelected = {
              _id: {
                tumbol_ID: getHouseHoldData.value.tumbol_code,
              },
              tumbol_name: getHouseHoldData.value.tumbol_name,
            }),
            (state.titleSelected = {
              id: getHouseHoldData.value.household_head.title,
              label: getHouseHoldData.value.household_head.title,
            }),
            (state.typeofFamilySelected = {
              id: getHouseHoldData.value.hh_type.code,
              label: getHouseHoldData.value.hh_type.desc,
            }),
            (state.houseTypeSelected = {
              id: getHouseHoldData.value.house_type.code,
              label: getHouseHoldData.value.house_type.desc,
            }),
            (stateHT.OGhouseTypeSelected = {
              id: getHouseHoldData.value.house_type.code,
              label: getHouseHoldData.value.house_type.desc,
            });
          if (getHouseHoldData.value.house_type.code === "HT2") {
            if (!getHouseHoldData.value.house_type.land_hiring) {
              (state.subHouseTypeSelected = {
                id: "อาศัยที่ดินผู้อื่น",
                label: "อาศัยที่ดินผู้อื่น",
              }),
                (stateHT.OGsubHouseTypeSelected = {
                  id: "อาศัยที่ดินผู้อื่น",
                  label: "อาศัยที่ดินผู้อื่น",
                });
            } else if (
              getHouseHoldData.value.house_type.land_hiring === "ผู้ให้เช่า"
            ) {
              (state.subHouseTypeSelected = {
                id: "เช่าที่ดิน",
                label: "เช่าที่ดิน",
              }),
                (stateHT.OGsubHouseTypeSelected = {
                  id: "เช่าที่ดิน",
                  label: "เช่าที่ดิน",
                }),
                (stateHT.detailSubHousetype =
                  getHouseHoldData.value.house_type.hiring_cost);
            }
          } else if (getHouseHoldData.value.house_type.code === "HT3") {
            (state.subHouseTypeSelected = {
              id: getHouseHoldData.value.house_type.public_land_type.code,
              label: getHouseHoldData.value.house_type.public_land_type.desc,
            }),
              (stateHT.OGsubHouseTypeSelected = {
                id: getHouseHoldData.value.house_type.public_land_type.code,
                label: getHouseHoldData.value.house_type.public_land_type.desc,
              });
            if (
              getHouseHoldData.value.house_type.public_land_type.code === "PL5"
            ) {
              stateHT.detailSubHousetype =
                getHouseHoldData.value.house_type.public_land_type.public_land_name;
            }
          } else if (getHouseHoldData.value.house_type.code === "HT4") {
            stateHT.detailSubHousetype =
              getHouseHoldData.value.house_type.rental_fee;
          } else if (getHouseHoldData.value.house_type.code === "HT5") {
            stateHT.detailSubHousetype =
              getHouseHoldData.value.house_type.house_type_name;
          }
          getMember(getHouseHoldData.value.hh_head);
          getDistrictEditmodal(state.provinceSelected);
          getSubDistrictEditmodal(
            state.districtSelected,
            state.provinceSelected
          );
          getVillageEditmodal(
            state.subDistrictSelected,
            state.districtSelected,
            state.provinceSelected
          );
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
const idState = () => {
  if (state.householdHeadIdCardNo.length == 13) {
    var sum, i;
    if (state.householdHeadIdCardNo.substring(0, 1) == 0) return false;
    for (i = 0, sum = 0; i < 12; i++)
      sum += parseFloat(state.householdHeadIdCardNo.charAt(i)) * (13 - i);
    if (
      (11 - (sum % 11)) % 10 !=
      parseFloat(state.householdHeadIdCardNo.charAt(12))
    )
      return false;
    return true;
  } else if (state.householdHeadIdCardNo.length > 1) {
    return false;
  } else {
    return null;
  }
};
const houseTypeChange = (houseType_data) => {
  state.houseTypeSelected = houseType_data;
  state.subHouseTypeSelected = { id: null, label: null };
  // state.subHouseTypeSelected = null
  stateHT.OGsubHouseTypeSelected = null;
  stateHT.detailSubHousetype = null;
};
const subHouseTypeChange = (subhouseType_data) => {
  state.subHouseTypeSelected = subhouseType_data;
};
const manageDetailHouseType = () => {
  if (state.houseTypeSelected.id === "HT1") {
    detailSubHouseTypeArr.value = {
      code: state.houseTypeSelected.id,
      desc: state.houseTypeSelected.label,
    };
  } else if (state.houseTypeSelected.id === "HT2") {
    if (state.subHouseTypeSelected.label === "เช่าที่ดิน") {
      detailSubHouseTypeArr.value = {
        code: state.houseTypeSelected.id,
        desc: state.houseTypeSelected.label,
        land_hiring: "ผู้ให้เช่า",
        hiring_cost: parseInt(stateHT.detailSubHousetype),
      };
    } else {
      detailSubHouseTypeArr.value = {
        code: state.houseTypeSelected.id,
        desc: state.houseTypeSelected.label,
      };
    }
  } else if (state.houseTypeSelected.id === "HT3") {
    if (state.subHouseTypeSelected.id === "PL5") {
      detailSubHouseTypeArr.value = {
        code: state.houseTypeSelected.id,
        desc: state.houseTypeSelected.label,
        public_land_type: {
          code: state.subHouseTypeSelected.id,
          desc: state.subHouseTypeSelected.label,
          public_land_name: stateHT.detailSubHousetype,
        },
      };
    } else {
      detailSubHouseTypeArr.value = {
        code: state.houseTypeSelected.id,
        desc: state.houseTypeSelected.label,
        public_land_type: {
          code: state.subHouseTypeSelected.id,
          desc: state.subHouseTypeSelected.label,
        },
      };
    }
  } else if (state.houseTypeSelected.id === "HT4") {
    detailSubHouseTypeArr.value = {
      code: state.houseTypeSelected.id,
      desc: state.houseTypeSelected.label,
      rental_fee: parseInt(stateHT.detailSubHousetype),
    };
  } else if (state.houseTypeSelected.id === "HT5") {
    detailSubHouseTypeArr.value = {
      code: state.houseTypeSelected.id,
      desc: state.houseTypeSelected.label,
      house_type_name: stateHT.detailSubHousetype,
    };
  }
};
const checkValidateHouseType = async () => {
  var isHTFormCorrect = await validateHT.value.$validate();
  if (state.houseTypeSelected.id === "HT1") {
    isHTFormCorrect = true;
  } else if (
    state.houseTypeSelected.id === "HT2" &&
    state.subHouseTypeSelected.label === "อาศัยที่ดินผู้อื่น"
  ) {
    isHTFormCorrect = true;
  } else if (
    state.houseTypeSelected.id === "HT3" &&
    state.subHouseTypeSelected.id !== "PL5" &&
    state.subHouseTypeSelected.id
  ) {
    isHTFormCorrect = true;
  } else if (
    state.houseTypeSelected.id === "HT4" &&
    stateHT.detailSubHousetype
  ) {
    isHTFormCorrect = true;
  } else if (
    state.houseTypeSelected.id === "HT5" &&
    stateHT.detailSubHousetype
  ) {
    isHTFormCorrect = true;
  }
  return isHTFormCorrect;
};
const submitAddHouseholdForm = async () => {
  submitBtn.value = true;
  var isFormCorrect = await v$.value.$validate();
  var isHTFormCorrect = await checkValidateHouseType();
  if (state.houseNoOption === 0) {
    state.houseNo = "";
    state.houseCode = "";
    if (
      v$.value.$errors[0].$propertyPath === "houseNo" &&
      v$.value.$errors.length === 1
    ) {
      isFormCorrect = true;
    }
  }
  if (checkClickbtn.value === null) {
    if (editModal.value) {
      checkClickbtn.value = true;
    } else {
      checkClickbtn.value = false;
    }
  }
  sumId.value = await idState();
  if (isFormCorrect && sumId.value && checkClickbtn.value && isHTFormCorrect) {
    swalCustom
      .fire({
        text: "ยืนยันบันทึกข้อมูล",
        icon: "info",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      })
      .then((result) => {
        if (result.isConfirmed) {
          if (editModal.value) {
            updateHouseHold();
          } else {
            sentApiHousehold();
          }

          // swalCustom.fire({
          //   html: `<div style="font-size:18px;"><b/>บันทึกข้อมูลสำเร็จ</div>`,
          //   icon: 'success',
          //   confirmButtonColor: '#142E71',
          //   timer: 3000})
          // closeModal()
        }
      });
  }
};
const updateHouseHold = async () => {
  manageDetailHouseType();
  try {
    await axios
      .put(
        `${process.env.VUE_APP_BASE_API}household/${getHouseHoldData.value._id} `,
        {
          update: {
            hh_type: {
              code: state.typeofFamilySelected.id,
              desc: state.typeofFamilySelected.label,
            },
            have_num: state.houseNoOption,
            hnum: state.houseNo,
            hh_code: state.houseCode,
            moo: moo.value,
            soi: lane.value,
            road: road.value,
            province_code: JSON.parse(
              JSON.stringify(state.provinceSelected._id.province_ID)
            ).toString(),
            province_name: JSON.parse(
              JSON.stringify(state.provinceSelected.province_name)
            ),
            village_code: JSON.parse(
              JSON.stringify(state.villageSelected._id.village_ID)
            ).toString(),
            village_name: JSON.parse(
              JSON.stringify(state.villageSelected.village_name)
            ),
            tumbol_code: JSON.parse(
              JSON.stringify(state.subDistrictSelected._id.tumbol_ID)
            ).toString(),
            tumbol_name: JSON.parse(
              JSON.stringify(state.subDistrictSelected.tumbol_name)
            ),
            amphur_code: JSON.parse(
              JSON.stringify(state.districtSelected._id.amphur_ID)
            ).toString(),
            amphur_name: JSON.parse(
              JSON.stringify(state.districtSelected.amphur_name)
            ),
            mso_osm: state.districtSelected.mso_osm.toString(),
            postcode: state.postCode,
            latitude: lat.value,
            longitude: lng.value,
            house_type: detailSubHouseTypeArr.value,
            house_solid: state.houseSolidOption,
            env_suitable: state.envSuitableOption,
            status: "modified",
            modified_by: store.getters["userInfo/getUserInfoForApi"],
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          swalCustom
            .fire({
              text: "สำเร็จ",
              icon: "success",
              timer: 3000,
              confirmButtonText: "ปิด",
            })
            .then(() => {
              closeModal("saved");
            });
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};
const sentApiMember = async (insert_id) => {
  state.birthdate = new Date(state.birthdate);
  state.birthdate.setUTCHours(0, 0, 0, 0);
  try {
     const splitFullName = (full) => {
      if (!full || String(full).trim() === '') return { name: '', surname: '' }
      const parts = String(full).trim().split(/\s+/)
      if (parts.length === 1) return { name: parts[0], surname: '' }
      const surname = parts.pop()
      const name = parts.join(' ')
      return { name, surname }
    }
    const fatherSplit = splitFullName(state.fathername)
    const motherSplit = splitFullName(state.mothername)
    const boraData = {
      sex: (state.gender === "1" || String(state.gender).includes("ชาย")) 
    ? "ชาย" 
    : (state.gender === "2" || String(state.gender).includes("หญิง")) 
        ? "หญิง" 
        : (state.gender || ''),
      nationality: state.nationality || '',
      // vital_status: state.personstatus === "ปกติ" ? 1 : 0,
      father: {
        title:"นาย",
        national_id: state.fatherpid || '',
        name: fatherSplit.name,
        surname: fatherSplit.surname,
        nationality: state.fathernationality || ''
      },
      mother: {
        title:"นาง",
        national_id: state.motherpid || '',
        name: motherSplit.name,
        surname: motherSplit.surname,
        nationality: state.mothernationality || ''
      }
    }
    let _d = {
          hh_id: insert_id,
          title: state.titleSelected.label,
          name: state.householdHeadFirstName,
          surname: state.householdHeadLastName,
          national_id: state.householdHeadIdCardNo,
          birthdate: state.birthdate,
          is_hh_head: 1,
          case_manager: {
            uid: managerData.value.uid,
            title: managerData.value.title,
            name: managerData.value.name,
            surname: managerData.value.surname,
          },
          volunteer: {
            uid: localstorageVT.uid,
            title: localstorageVT.title,
            name: localstorageVT.name,
            surname: localstorageVT.surname,
            national_id: localstorageVT.national_id,
          },
          have_num: state.houseNoOption,
          hnum: state.houseNo,
          hh_code: state.houseCode,
          moo: moo.value,
          soi: lane.value,
          road: road.value,
          postcode: state.postCode,
          province_code: JSON.parse(
            JSON.stringify(state.provinceSelected._id.province_ID)
          ).toString(),
          province_name: JSON.parse(
            JSON.stringify(state.provinceSelected.province_name)
          ),
          village_code: JSON.parse(
            JSON.stringify(state.villageSelected._id.village_ID)
          ).toString(),
          village_name: JSON.parse(
            JSON.stringify(state.villageSelected.village_name)
          ),
          tumbol_code: JSON.parse(
            JSON.stringify(state.subDistrictSelected._id.tumbol_ID)
          ).toString(),
          tumbol_name: JSON.parse(
            JSON.stringify(state.subDistrictSelected.tumbol_name)
          ),
          amphur_code: JSON.parse(
            JSON.stringify(state.districtSelected._id.amphur_ID)
          ).toString(),
          amphur_name: JSON.parse(
            JSON.stringify(state.districtSelected.amphur_name)
          ),
          mso_osm: state.districtSelected.mso_osm.toString(),
          status: "created",
          created_by: store.getters["userAuth/getUsername"],
          msoid: state.householdHeadIdCardNo
            ? md5(insert_id + state.householdHeadIdCardNo)
            : md5(
                insert_id +
                  state.householdHeadFirstName +
                  state.householdHeadLastName
              ),
        };
        if (boraInfoDisplay.value) {
      _d = { ..._d, ...boraData }
    }
    await axios
      .post(`${process.env.VUE_APP_BASE_API}member/`, {
        doc: _d
      })
      .then((res) => {
        if (res.status === 200) {
          swalCustom
            .fire({
              text: "สำเร็จ",
              icon: "success",
              timer: 3000,
              confirmButtonText: "ปิด",
            })
            .then(() => {
              closeModal("saved");
            });
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  } catch (error) {
    console.log(error.message);
    swalCustom.fire({
      text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
      icon: "warning",
      //timer: 3000, //timeOut for auto-close
      confirmButtonText: "ปิด",
    });
  }
};
const sentApiHousehold = async () => {
  manageDetailHouseType();
  try {
    await axios
      .post(`${process.env.VUE_APP_BASE_API}household/`, {
        doc: {
          hh_head: state.householdHeadIdCardNo,
          latitude: lat.value,
          longitude: lng.value,
          hh_type: {
            code: state.typeofFamilySelected.id,
            desc: state.typeofFamilySelected.label,
          },
          have_num: state.houseNoOption,
          hnum: state.houseNo,
          hh_code: state.houseCode,
          moo: moo.value,
          soi: lane.value,
          road: road.value,
          postcode: state.postCode,
          province_code: JSON.parse(
            JSON.stringify(state.provinceSelected._id.province_ID)
          ).toString(),
          province_name: JSON.parse(
            JSON.stringify(state.provinceSelected.province_name)
          ),
          village_code: JSON.parse(
            JSON.stringify(state.villageSelected._id.village_ID)
          ).toString(),
          village_name: JSON.parse(
            JSON.stringify(state.villageSelected.village_name)
          ),
          tumbol_code: JSON.parse(
            JSON.stringify(state.subDistrictSelected._id.tumbol_ID)
          ).toString(),
          tumbol_name: JSON.parse(
            JSON.stringify(state.subDistrictSelected.tumbol_name)
          ),
          amphur_code: JSON.parse(
            JSON.stringify(state.districtSelected._id.amphur_ID)
          ).toString(),
          amphur_name: JSON.parse(
            JSON.stringify(state.districtSelected.amphur_name)
          ),
          mso_osm: state.districtSelected.mso_osm.toString(),
          house_type: detailSubHouseTypeArr.value,
          house_solid: state.houseSolidOption,
          env_suitable: state.envSuitableOption,
          case_manager: {
            uid: managerData.value.uid,
            title: managerData.value.title,
            name: managerData.value.name,
            surname: managerData.value.surname,
          },
          volunteer: {
            uid: localstorageVT.uid,
            title: localstorageVT.title,
            name: localstorageVT.name,
            surname: localstorageVT.surname,
            national_id: localstorageVT.national_id,
          },
          status: "created",
          created_by: store.getters["userAuth/getUsername"],
        },
      })
      .then((res) => {
        if (res.status === 200) {
          sentApiMember(res.data.insertedId);
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  } catch (error) {
    console.log(error.message);
    swalCustom.fire({
      text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
      icon: "warning",
      //timer: 3000, //timeOut for auto-close
      confirmButtonText: "ปิด",
    });
  }
};
const closeModal = (clearModal) => {
  if (!submitBtn.value) {
    swalCustom
      .fire({
        html: `<div style="font-size:18px;"><b/>คุณต้องการออกจากหน้านี้ใช่หรือไม่</div>`,
        icon: "warning",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        allowOutsideClick: false,
      })
      .then((result) => {
        if (result.isConfirmed) {
          emit("modal-value", clearModal);
          cash("#header-footer-modal-preview-household").modal("hide");
          v$.value.$reset();
          validateHT.value.$reset();
          clearValue();
        }
      });
  } else {
    emit("modal-value", clearModal);
    cash("#header-footer-modal-preview-household").modal("hide");
    v$.value.$reset();
    validateHT.value.$reset();
    clearValue();
  }
};
const clearValue = () => {
  state.houseNo = null;
  state.houseCode = null;
  state.householdHeadFirstName = null;
  state.householdHeadLastName = null;
  state.householdHeadIdCardNo = "";
  state.postCode = null;
  state.villageSelected = null;
  state.provinceSelected = null;
  state.districtSelected = null;
  state.subDistrictSelected = null;
  state.titleSelected = null;
  // state.houseTypeSelected = null;
  stateHT.OGhouseTypeSelected = null;
  stateHT.OGsubHouseTypeSelected = null;
  stateHT.detailSubHousetype = null;
  state.envSuitableOption = 1;
  state.houseNoOption = 1;
  state.houseSolidOption = 1;
  state.typeofFamilySelected = null;
  state.birthdate = null;
  showHouseheadLayout.value = false;
  showBoraButton.value = false;
  boraInfoDisplay.value = null;
  // districtArr.value = null
  // subDistrictArr.value = null;
  // villageArr.value = ref([]);
  lat.value = 13.720564133220474;
  lng.value = 100.49031257629396;
  moo.value = "";
  road.value = "";
  lane.value = "";
  filename.value = "";
  imageUrl.value = "";
  sumId.value = true;
  filelist.value = [];
  editModal.val = false;
};
// แปลง dateofbirth จากรูปแบบ พ.ศ. YYYYMMDD (เช่น 25380101) เป็น ISO date
const formatDateofbirthToDate = (dateofbirth) => {
  if (!dateofbirth || String(dateofbirth).trim() === "") return "";
  const s = String(dateofbirth).trim();
  if (s.length !== 8) return "";
  const yearBE = parseInt(s.slice(0, 4), 10);
  const month = s.slice(4, 6);
  const day = s.slice(6, 8);
  const yearCE = yearBE - 543;
  const monthNum = parseInt(month, 10);
  const dayNum = parseInt(day, 10);
  if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) return "";
  const date = new Date(Date.UTC(yearCE, monthNum - 1, dayNum, 0, 0, 0, 0));
  if (isNaN(date.getTime())) return "";
  return date.toISOString();
};

const useBoraInfo = async () => {
  if (state.householdHeadIdCardNo.length !== 13) {
    swalCustom.fire({
      text: "กรุณากรอกเลขบัตรประชาชน 13 หลักก่อนตรวจสอบกับทะเบียนราษฎร์",
      icon: "warning",
      confirmButtonText: "ปิด",
    });
    return;
  }
  const idValid = idState();
  if (!idValid) {
    swalCustom.fire({
      text: "กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง",
      icon: "warning",
      confirmButtonText: "ปิด",
    });
    return;
  }

  // const token = "some token";
  // const config = {
  //     url: `BORA url`,
  //     method: 'POST',
  //     headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": `application/json; charset=utf-8`,
  //     },
  //     data: {
  //         nid: state.householdHeadIdCardNo
  //     }
  // };
  // const res = await axios(config);
  // const boraInfo = res.data;

  // ตอนนี้ assume ว่าข้อมูลจากทะเบียนราษฎร์มี format เหมือนข้อมูลด้านล่าง
  // Mapping: pid→national_id, title→title, firstname→name, lastname→surname, gender→sex,
  // dateofbirth→birthdate, nationality→nationality, personstatus→vital_status,
  // houseid→bora.houseid, housenumber→hnum, moo→moo, alley→bora.alley, soi→soi, road→road,
  // subdistrict→tumbol_name, district→amphur_name, province→province_name

  //------- Test Data -------//
  const boraHhInfo = Object.freeze(
    // await boraHouseholdInfo(state.householdHeadIdCardNo)
  );
  const boraInfo = Object.freeze(
    await getPersonInfoFromBora(state.householdHeadIdCardNo)
  );
  // ถ้า คืน null แปลว่าไปจัดการ alert (เช่น ให้ login ThaID / error อื่น)
  if (!boraInfo) {
    return;
  }
  // if (
  //   (boraInfo.Code !== undefined && boraInfo.Code !== "0") ||
  //   !boraInfo.pid
  // ) {
  //   swalCustom.fire({
  //     text: "ไม่พบข้อมูลจากทะเบียนราษฎร์",
  //     icon: "warning",
  //     confirmButtonText: "ปิด",
  //   });
  //   return;
  // }
  if (boraInfo.province !== store.getters["userAuth/getUserProvinceName"]) {
    swalCustom.fire({
      text: "ที่อยู่ตามทะเบียนราษฎร์ ไม่อยู่ในพื้นที่รับผิดชอบ",
      icon: "warning",
      confirmButtonText: "ปิด",
    });
    return;
  }

  state.houseNo = boraInfo.housenumber?.toString() ?? "";
  state.houseNoOption = state.houseNo === "" ? 0 : 1;
  if (state.houseNoOption) {
    state.houseCode = boraInfo.houseid?.toString() ?? "";
  }
  moo.value = boraInfo.moo?.toString() ?? "";
  lane.value = boraInfo.soi?.toString() ?? "";
  road.value = boraInfo.road?.toString() ?? "";
  await useBoraInfoHelper(boraInfo, "amphur");
  await useBoraInfoHelper(boraInfo, "tumbol");
  // state.postCode = boraHhInfo.ZipCode?.toString() ?? "";

  if (!editModal.value) {
    // const boraTitle = titles.find((title) => title.label === boraInfo.title);
    // state.titleSelected = boraTitle || null;
    // state.householdHeadFirstName = boraInfo?.firstname || null;
    // state.householdHeadLastName = boraInfo?.lastname || null;
    // const isoBirth = formatDateofbirthToDate(boraInfo?.dateofbirth);
    // state.birthdate = isoBirth ? new Date(isoBirth) : null;
    const boraTitle = titles.find((title) => title.label === boraInfo.title);
    state.titleSelected = boraTitle || null;
    state.householdHeadFirstName = boraInfo?.firstname || null;
    state.householdHeadLastName = boraInfo?.lastname || null;
    state.dateofbirth = boraInfo?.dateofbirth || '';
    const isoBirth = formatDateofbirthToDate(boraInfo?.dateofbirth);
    state.birthdate = isoBirth ? new Date(isoBirth) : null;
    state.gender = boraInfo?.gender || '';
    state.nationality = boraInfo?.nationality || '';
    // state.personstatus = boraInfo?.personstatus || '';
    state.fatherpid = boraInfo?.fatherpid || '';
    state.motherpid = boraInfo?.motherpid || '';
    state.fathername = boraInfo?.fathername || '';
    state.mothername = boraInfo?.mothername || '';
    state.fathernationality = boraInfo?.fathernationality || '';
    state.mothernationality = boraInfo?.mothernationality || '';
    boraInfoDisplay.value = true;
  }
};
const areaArr = Object.freeze({
  "amphur": districtArr,
  "tumbol": subDistrictArr,
  "village": villageArr
});
const useBoraInfoHelper = async (boraInfo, areaType) => {
  const areaObj = areaArr[areaType].value.find(
    (area) => area[`${areaType}`] === boraInfo[`${areaType}`]
  );

  if (areaObj) {
    switch (areaType) {
      case "amphur":
        state.districtSelected = areaObj;
        await getSubDistrict(areaObj);
        await useBoraInfoHelper(boraInfo, "tumbol");
        break;
      case "tumbol":
        state.subDistrictSelected = areaObj;
        await getVillage(areaObj);
        // await useBoraInfoHelper(boraInfo, "village");
        break;
      case "village":
        state.villageSelected = areaObj;
        break;
      default:
        console.log(`areaType ต้องเป็น amphur/tumbol/village เท่านั้น แต่นี่เป็น ${areaType}`);
    }
  }
};
</script>
<style lang="scss">
.add-photo {
  height: 100px;
  width: 110px;
  background-color: rgb(237, 241, 245);
  border: 3px solid #7988bf;
  border-radius: 15px;
}
.selecthh .vs__dropdown-toggle {
  background: white !important;
}
// .selecthh{
// z-index:20000 !important;
// }
.selecthh .vs__dropdown-menu {
  z-index: 20000 !important;
}
#header-footer-modal-preview-household {
  .vs--disabled .vs__search,
  .vs--disabled .vs__selected,
  .vs--disabled .vs__dropdown-toggle {
    background-color: rgba(247, 250, 252, var(--tw-bg-opacity)) !important;
  }
}
</style>
